module.exports = __webpack_public_path__ + "img/sharepageimage.bcbb5aa6.svg";